import React from 'react';
import { Separator, Stack } from '@fluentui/react';
import {
  useNavigate, useLocation, Routes, Route,
} from 'react-router-dom';
import Store from '../shared/state/Store';
import CloudUsageAllowances from '../admin-dashboard/CloudUsageAllowances';
import LicensesActivations from '../admin-dashboard/LicensesActivations';
import EndUsers from '../admin-dashboard/EndUsers';
import Menu, { DefaultNavOption } from '../admin-dashboard/Menu';
import StackTokens from '../shared/StackTokens';
import Theme from '../shared/Theme';
import Routing from '../shared/Routing';

export default () => {
  const [globalState] = Store.useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const routingTree = Routing.getTree(globalState).home.routes.administrationDashboard;

  React.useEffect(() => {
    if (location.pathname === routingTree.path) {
      // If no subcomponent selected, navigate to default subcomponent
      navigate(DefaultNavOption, { replace: true });
    }
  }, [location.pathname]);

  return (
    <Stack vertical>
      <header className={Theme.styles.menuHeader}>Administration Dashboard</header>

      <Stack horizontal tokens={StackTokens.spacing}>
        <Stack vertical>
          <Menu />
        </Stack>
        <Separator vertical />
        <Stack vertical grow>
          <Routes>
            <Route element={<CloudUsageAllowances />} path={routingTree.routes.cloudUsageAllowances.getRelativePath(routingTree.path)} />
            <Route element={<LicensesActivations />} path={routingTree.routes.licensesActivations.getRelativePath(routingTree.path)} />
            <Route element={<EndUsers />} path={routingTree.routes.endUsers.getRelativePath(routingTree.path)} />
          </Routes>
        </Stack>
      </Stack>
    </Stack>
  );
};
